export default "__VITE_ASSET__BbjBzsJ8__"